import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import UserDashboard from './UserDashboard';
import AdminDashboard from './AdminDashboard';
import AdminUserView from './AdminUserView';
import { 
  CircularProgress, 
  Typography, 
  Box, 
  Container, 
  Paper
} from '@mui/material';

const Dashboard = () => {
  const { user, loading } = useAuth();
  const [adminUserViewMode, setAdminUserViewMode] = useState(false);
  
  // Check if admin has enabled user view mode
  useEffect(() => {
    if (user?.is_admin) {
      const savedViewMode = localStorage.getItem('adminUserViewMode');
      setAdminUserViewMode(savedViewMode === 'true');
    }
  }, [user]);
  
  // Listen for changes to the localStorage value
  useEffect(() => {
    const handleStorageChange = () => {
      if (user?.is_admin) {
        const savedViewMode = localStorage.getItem('adminUserViewMode');
        setAdminUserViewMode(savedViewMode === 'true');
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [user]);
  
  const toggleViewMode = () => {
    const newMode = !adminUserViewMode;
    setAdminUserViewMode(newMode);
    localStorage.setItem('adminUserViewMode', newMode);
    window.dispatchEvent(new Event('storage'));
  };

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return (
      <Container maxWidth="sm">
        <Paper 
          elevation={3} 
          sx={{ 
            mt: 8, 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center' 
          }}
        >
          <Typography variant="h5" color="error" gutterBottom>
            Authentication Error
          </Typography>
          <Typography variant="body1">
            You are not authenticated. Please log in to access the dashboard.
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Container maxWidth="lg" sx={{ pt: 2, pb: 4 }}>
        {user.is_admin ? (
          adminUserViewMode ? (
            <AdminUserView onSwitchView={toggleViewMode} />
          ) : (
            <AdminDashboard />
          )
        ) : (
          <UserDashboard />
        )}
      </Container>
    </Box>
  );
};

export default Dashboard;